import { Body } from '@vrzl/ui';

import { answerSources } from '@/domains/overview/utils/sources';

import type { ValidationReportItem } from '../api/types';
import { criterionFindings, MISSING_SUMMARY } from '../utils/criterionFindings';
import type { CriterionStatus } from '../utils/validationView';

import { SourceReference } from './sourceReference';

const INCONSISTENT_INTRO = 'Deze documenten spreken elkaar tegen. Ga zelf na welke klopt.';
const MISSING_EXPLANATION =
  'Niet teruggevonden in de aangeleverde documenten. Dat betekent niet automatisch dat het niet geregeld is: het kan ergens anders beschreven staan of nog niet zijn aangeleverd.';

type CriterionDetailProps = {
  item: ValidationReportItem;
  status: CriterionStatus;
  eventId: string;
};

/** Inhoud van een uitgeklapte criteriumrij, per status. */
export function CriterionDetail({ item, status, eventId }: CriterionDetailProps) {
  if (status === 'missing') {
    return <Body tone="muted">{MISSING_EXPLANATION}</Body>;
  }

  if (status === 'inconsistent') {
    return (
      <div className="space-y-3">
        <Body tone="muted">{INCONSISTENT_INTRO}</Body>
        <ul className="grid gap-3 sm:grid-cols-2">
          {item.answers.map((answer, i) => (
            <li key={i} className="space-y-1 rounded-md border border-border p-3">
              <Body weight="medium" className="wrap-break-word">
                {answer.value ?? MISSING_SUMMARY}
              </Body>
              {answerSources(answer, item.documents).map((source) => (
                <SourceReference
                  key={source.docId}
                  eventId={eventId}
                  criterionId={item.id}
                  source={source}
                  highlightQuery={answer.value ?? undefined}
                />
              ))}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  const findings = criterionFindings(item);
  if (findings.length === 0) return null;
  return (
    <ul className="space-y-3">
      {findings.map((finding, i) => (
        <li key={i} className="border-l-2 border-border pl-3">
          <Body className="wrap-break-word">{finding.text}</Body>
          {finding.source && (
            <SourceReference
              eventId={eventId}
              criterionId={item.id}
              source={finding.source}
              highlightQuery={finding.highlight}
            />
          )}
        </li>
      ))}
    </ul>
  );
}
